<template>
  <div
    class="text-center padding"
    :class="{'white': $store.state.slide.textColour == '#ffffff',
             'content-bulletpoint':$store.state.slide.type == 'bulletPoints'}"
  >
    <div v-if="slide.title || slide.subheading">
      <h2
        class="mt-0 title slide-title-style"
        :class="{'title-bulletPoints': slide.type == 'bulletPoints'}"
        v-html="dataValue"
      />
      <p
        class="mb-3 subheading text-break"
        :class="{'subheading-bulletPoints':slide.type == 'bulletPoints'}"
        :inner-html.prop="slide.subheading | sanitize(true)"
      />
    </div>

    <!-- no content -->
    <div
      class="no-data"
      v-if="(!slide.title && !$store.state.slide.subheading && $store.state.slide.type == 'textSlide') || (!$store.state.slide.SlideOptions.length && $store.state.slide.type == 'bulletPoints' && !$store.state.slide.title && !$store.state.slide.subheading)"
    >
      <p class="mb-3">
        {{ $t("blankSlide") }}
      </p>
    </div>

    <div class="audio-control-slide" v-if="$store.state.slide.audioLink && $store.state.slide.audioPlayOnAudience && $store.state.slide.id">
      <AudioControl />
    </div>

    <!-- BulletPoint -->
    <div class="bullet-list-wrapper" v-if="$store.state.slide.type == 'bulletPoints'">
      <ul class="bullet-list">
        <div v-for="(item, index) in $store.state.slide.SlideOptions" :key="index">
          <transition name="popup">
            <li
              v-if="(!$store.state.slide.showAllBulletPoints && $store.state.slide.bulletPointsIndex > index && !$store.state.presentation.audiencePacing)
                || $store.state.slide.showAllBulletPoints ||
                !$store.state.slide.showAllBulletPoints && $store.state.presentation.audiencePacing"
              class="bullet-list-item"
              v-show="isVisibleOption(index)"
            >
              <div
                v-if="item.id"
                class="bullet-list-item-text"
                :inner-html.prop="item.title | sanitize(true)"
              />
              <div v-if="!item.id" class="bullet-list-item-text">
                Bullet {{ index }}
              </div>
            </li>
          </transition>
        </div>
      </ul>
    </div>
  </div>
</template>
<script>
import AudioControl from '@/components/AudioControl.vue'
import { mapState } from 'vuex'
import ClickableTitleMixin from '@/mixins/ClickableTitleMixin'

export default {
  components: {
    AudioControl,
  },
  computed: {
    ...mapState({
      slide: (state) => state.slide,
    }),
  },
  mixins: [ClickableTitleMixin],
  methods: {
    isVisibleOption(index) {
      return index < 15
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.icobutton--haha.active {
  span {
    color: $reaction-smiley-color !important;
  }
}
.icobutton--heart.active {
  span {
    color: rgb(243, 81, 134) !important;
  }
}
.icobutton--question.active {
  span {
    color: rgb(111, 151, 247) !important;
  }
}
.icobutton--like.active {
  span {
    color: $reaction-thumbs-up-color !important;
  }
}
.icobutton--dislike.active {
  span {
    color: rgb(255, 103, 103) !important;
  }
}
.text-center {
  text-align: center;
}

.padding {
  padding: 0 16px;
}

.title {
  font-weight: bold;
  font-size: 28px;
  margin-bottom: 0;
}

.title-bulletPoints {
  padding-bottom: 0;
}

.subheading {
  font-size: 18px;
  height: 100%;
  white-space: pre-line;
  line-height: 25px;
  opacity: 0.7;
  margin-top: 18px;
}

.popup-enter-active {
  transition: all 0.4s ease;
}
.popup-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
  transform: scale(1.5);
}
.popup-enter, .popup-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: scale(0.5);
  opacity: 0;
}
.bullet-list-wrapper {
  text-align: left;
  margin-top: 18px;
  .bullet-list {
    padding-inline-start: 0;
    margin: 0 36px;
  }

  .bullet-list-item {
    margin-bottom: 8px;
    font-size: 18px;

    .bullet-list-item-text {
      display: inline;
      word-break: break-word;
    }
  }
}

.audio-control-slide {
  margin-top: 18px;
}
</style>
